




























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class RoundCardPosition extends Vue {
  looksFlipped = false as boolean

  flipping = false as boolean

  yRotation = 0 as number

  @Prop() boardHeight: number

  @Prop() boardWidth: number

  @Prop() cardAttack: number

  @Prop() cardHealth: number

  @Prop() flipped: boolean

  @Prop() flipTimeMs: number

  @Prop() rotationDeg: number

  get displayRotation() {
    if (this.rotationDeg < 0 || this.rotationDeg >= 180) {
      return this.rotationDeg + 90;
    }
    return (this.rotationDeg - 90) % 180;
  }

  get left() {
    return Math.cos(this.rotationDeg / 180 * Math.PI)
      * (this.boardWidth - 120) / 2
      + this.boardWidth / 2 - 40;
  }

  get top() {
    return Math.sin(this.rotationDeg / 180 * Math.PI)
      * (this.boardHeight - 120) / 2
      + this.boardHeight / 2 - 50;
  }

  @Watch('flipped', { immediate: true })
  onFlippedChanged() {
    if (this.flipped !== this.looksFlipped) {
      this.flip();
    }
  }

  clicked() {
    if (this.flipped) {
      this.$emit('clicked');
    }
  }

  flip() {
    if (this.flipping) {
      return;
    }
    this.flipping = true;
    this.yRotation = 90;
    setTimeout(() => {
      this.yRotation = -90;
      this.looksFlipped = !this.looksFlipped;
      this.yRotation = 0;
      setTimeout(() => { this.flipping = false; }, this.flipTimeMs / 2);
    }, this.flipTimeMs / 2);
  }
}
